import { useAuthUser } from '@/helpers/globals';
import { useBrowserStorage } from '@kp/geofy-vuejs-lib/tools/browser_local_storage.js';
import { instance as api } from '@/helpers/api';





/**
 * Creates a reactive connection between a UserCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */
export async function generateGemeindeRelationship(id: number | null): Promise<void> {
    const authUser = useAuthUser();
    const { setStorageValue, getStorageValue } = useBrowserStorage('eplan');

    try {
        if (!id) {
            return;
        }
        const stelle_id = authUser?.active_role_stelle_id;
        console.log('stelle_' + stelle_id + '_email');
        const email = getStorageValue('stelle_' + stelle_id + '_email', null);
        const phone = getStorageValue('stelle_' + stelle_id + '_phone', null);
        await api().post('/Planungsgeschaeft/generateGemeindeRelationship', {
            planungsgeschaeft_id: id,
            email,
            phone
        });
    } catch (err) {
        console.error(err);
    }
}
